import Interaction from "../../../models/interactions/Interaction";
import { IIf, IfOperator } from "../../../models/interactions/If";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import VariableSelector from "../variables/VariableSelector";
import TypedMatchInput from "../components/TypedMatchInput";
import { useSelector } from "react-redux";
import { selectSequenceVariables } from "../../../app/slices/TrainingSlice";
import { VariableType } from "../../../models/interactions/Variable";

export default function IfNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const ifNode = props.interaction as IIf;
  const { updateInteraction } = useUpdateSequenceInteraction();
  const variables = useSelector(selectSequenceVariables);

  return (
    <div className="w-full h-full flex flex-col gap-[12px] pb-[24px]">
      <VariableSelector
        variables={variables}
        selectedVariableId={ifNode.variable}
        label="Variable"
        filterByType={
          ifNode.operator === IfOperator.Equal ||
          ifNode.operator === IfOperator.NotEqual
            ? undefined
            : VariableType.Number
        }
        onSelect={(variableId) =>
          updateInteraction(props.nodeId, {
            ...ifNode,
            variable: variableId,
            match: "",
          } as IIf)
        }
      />
      <TypedMatchInput
        label="Match"
        value={ifNode.match}
        onChange={(match) =>
          updateInteraction(props.nodeId, {
            ...ifNode,
            match,
          } as IIf)
        }
        variableType={
          variables.find((v) => v.id === ifNode.variable)?.type ?? null
        }
        variables={variables}
        excludeVariableId={ifNode.variable || undefined}
      />
    </div>
  );
}
